import React, { useState, useCallback, useRef } from "react";
import Timer from "./Timer";
import capitals from "../utils/capitals.json";
import { getNewCountry } from "../utils/util";
import { Button, Container, Form, Row, Col } from "react-bootstrap";
import ScoreModal from "./ScoreModal";

export default function CapitalsGameHard({
  hardGameInProgress,
  hardHighScore,
  usedCountry,
  startingCountry,
}) {
  const [score, setScore] = useState(0);
  const scoreRef = useRef(score);
  scoreRef.current = score;
  const [country, setCountry] = useState(startingCountry);
  const [capitalInput, setCapitalInput] = useState("");
  const [showModal, setShowModal] = useState(false);

  const handleGameOver = useCallback(() => {
    const updateHighScore = async (score) => {
      try {
        if (score <= hardHighScore) return;
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/updateCapitalsGameHighScore`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              mode: "hard",
              score: score,
            }),
          }
        );
        if (!response.ok) {
          throw new Error("Failed to update high score");
        }
      } catch (err) {
        console.error("Error updating high score:", err);
      }
    };
    setShowModal(true);
    updateHighScore(scoreRef.current);
  }, [hardHighScore]);

  const skipHandler = (e) => {
    e.preventDefault();
    setCountry(getNewCountry(usedCountry));
    setCapitalInput("");
  };

  const handleInputChange = (e) => {
    e.preventDefault();
    const inputCapital = e.target.value;
    setCapitalInput(inputCapital);

    if (inputCapital.toLowerCase() === capitals[country].toLowerCase()) {
      setScore((prevScore) => prevScore + 1);
      setCapitalInput("");
      setCountry(getNewCountry(usedCountry));
    }
  };

  return (
    <Container>
      <Row md={6} sm={12}>
        <Col>
          <Timer
            gameInProgress={hardGameInProgress}
            handleGameOver={handleGameOver}
          />
        </Col>
        <Col>
          <h5>Score: {score}</h5>
        </Col>
        <Col>
          <h5>High Score: {hardHighScore} </h5>
        </Col>
      </Row>
      {hardGameInProgress && (
        <div>
          <Form onSubmit={skipHandler}>
            <Form.Group className="mb-3" controlId="country">
              <Form.Label className="fs-1 display-2">{country}</Form.Label>
              <Form.Control
                type="string"
                name="capital"
                value={capitalInput}
                onChange={handleInputChange}
                autoFocus={true}
              />
            </Form.Group>

            <Button variant="secondary" type="submit">
              Skip
            </Button>
          </Form>
        </div>
      )}

      <ScoreModal 
        show={showModal} 
        handleClose={() => setShowModal(false)} 
        score={score} 
        highScore={hardHighScore} 
      />
    </Container>
  );
}
